import { createAction, props } from '@ngrx/store';
import { UserRole } from '@p2p/users/domain';

import { PermissionsResponse } from '../entities/permissions-response';

const actionFeatureKey = 'Access Control';

export const loadPermissions = createAction(`[${actionFeatureKey}] Load Permissions`, props<{ role: UserRole }>());
export const loadPermissionsSuccess = createAction(
    `[${actionFeatureKey}] Load Permissions Success`,
    props<PermissionsResponse>()
);
